import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { HpSharedHeroCarousel } from './HpSharedHeroCarousel';

import { type HpSharedHeroModule_viewer$key } from './__generated__/HpSharedHeroModule_viewer.graphql';
import { type HpSharedHeroModule_user$key } from './__generated__/HpSharedHeroModule_user.graphql';

const viewerFragment = graphql`
    fragment HpSharedHeroModule_viewer on Viewer {
        ...HpSharedHeroCarousel_viewer @include(if: $isClient)
    }
`;

const userFragment = graphql`
    fragment HpSharedHeroModule_user on User {
        ...HpSharedHeroCarousel_user
    }
`;

export const HpSharedHeroModule: FC<{
    viewer: HpSharedHeroModule_viewer$key;
    user?: HpSharedHeroModule_user$key | null;
    isMobile: boolean;
    isClient?: boolean;
}> = ({ viewer: viewerRef, user: userRef, isMobile, isClient }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const user = useFragment(userFragment, userRef);

    return (
        <HpSharedHeroCarousel viewer={isClient ? viewer : null} user={user} isMobile={isMobile} />
    );
};
